import BaseChannel from "../base_channel.js";
import { camelizeKeys } from "../../utils/utils.js";

class InvestmentPaymentTransactionChannel extends BaseChannel {

  constructor(investment) {
    super();
    this.investment = investment
  }

  subscribe = (onDataReceived) => {
    BaseChannel.initConsumerIfNeed();
    const { consumer: { subscriptions } } = window;
    
    this.channel = subscriptions.create({channel: this.channelName(), id: this.investment.id}, {
      received(data) {
        if(onDataReceived) {
          onDataReceived(camelizeKeys(data));
        }
      }
    });
  }

  channelName = () => {
    return "InvestmentPaymentTransactionChannel";
  }
}

export default InvestmentPaymentTransactionChannel;